import React from "react";
import "./Calender.css";

export default function Calender(props) {
    return (
        <>
            <div className="calender-container">
                 <iframe
                    title="Google Calendar"
                    src="https://calendar.google.com/calendar/embed?src=acadoutreachiitdelhi%40gmail.com&ctz=Asia%2FKolkata"
                    style={{ border: "none" }}
                    className="calender"
                    // width="100%"
                    // height="600"
                    scrolling="no"
                ></iframe>
            </div>
        </>
    )
}